import React from "react";
import Loader from 'react-loader-spinner'
import Modal from "../components/Modal";
import StagesManager from "../components/StagesManager";
import { translate } from "../utils/useful";
import AddPermissionHome from "./AddPermission/AddPermissionHome";
import AddPermissionUsers from "./AddPermission/AddPermissionUsers";


class AddPermissionModal extends React.Component {
  state = {
    // isLoadingRemove: false,
    // id: null,
    // index: null
  }

  onDone = (list, type) => {
    this.props.onDone(list, type)
    this.modal.hideModal()
  }

  open = () => {

    this.modal.showModal(() => {
      setTimeout(() => {
        let tab = this.props.initTab ?? (this.props.currentRole ? 'hubs' : 'roles')
        this.permissionHome.setTab(tab)
      }, 10);
    })

  }


  render() {

    // console.log(this.props.isAssign)
    return (
      <Modal cancelModal={this.props.cancelModal} ref={el => this.modal = el} maxWidth={400} className="flexcc ">
        <div className="w-100 h-100 position-relative" style={{ backgroundColor: '#fff', borderRadius: 8 }}>


          <StagesManager height={'100%'} ref={el => this.stagesManager = el}>
            {/* <AddPermissionUsers stage={0} stageName="home" /> */}
            <AddPermissionHome stage={0} stageName="home" ref={el => this.permissionHome = el} onDone={this.onDone} roles={this.props.roles} variables={this.props.variables} groups={this.props.groups} hubs={this.props.hubs} currentRole={this.props.currentRole} allRoles={this.props.allRoles} />
          </StagesManager>



        </div>

      </Modal >
    );
  }
}



export default AddPermissionModal;
